import React from 'react';
import { CheckCircle2, Clock, AlertCircle, TrendingUp } from 'lucide-react';

export const ProductMockup = () => {
  return (
    <div className="relative">
      {/* Browser frame */}
      <div className="bg-white rounded-2xl shadow-2xl border-2 border-stone-200 overflow-hidden transform perspective-1000 rotate-y-2">
        {/* Browser chrome */}
        <div className="bg-stone-100 px-4 py-3 border-b border-stone-200 flex items-center space-x-2">
          <div className="flex space-x-2">
            <div className="w-3 h-3 rounded-full bg-red-400"></div>
            <div className="w-3 h-3 rounded-full bg-yellow-400"></div>
            <div className="w-3 h-3 rounded-full bg-green-400"></div>
          </div>
          <div className="flex-1 bg-white rounded px-3 py-1 mx-4">
            <span className="text-xs text-stone-400">practicio.io/projects</span>
          </div>
        </div>
        
        {/* Dashboard content */}
        <div className="bg-gradient-to-br from-stone-50 to-white p-6 space-y-6">
          {/* Header */}
          <div className="flex items-center justify-between pb-4 border-b border-stone-200">
            <div>
              <h3 className="text-lg font-bold text-stone-900">Bandra Residence Renovation</h3>
              <p className="text-sm text-stone-500">Client: Sharma Family</p>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-green-500 rounded-full"></div>
              <span className="text-sm text-stone-600">Active</span>
            </div>
          </div>
          
          {/* Stats row */}
          <div className="grid grid-cols-4 gap-4">
            <div className="bg-white rounded-lg p-3 border border-stone-200 shadow-sm">
              <div className="flex items-center space-x-2 mb-1">
                <CheckCircle2 className="w-4 h-4 text-green-600" />
                <span className="text-xs text-stone-500">Approved</span>
              </div>
              <p className="text-2xl font-bold text-stone-900">12</p>
            </div>
            <div className="bg-white rounded-lg p-3 border border-stone-200 shadow-sm">
              <div className="flex items-center space-x-2 mb-1">
                <Clock className="w-4 h-4 text-amber-600" />
                <span className="text-xs text-stone-500">Pending</span>
              </div>
              <p className="text-2xl font-bold text-stone-900">5</p>
            </div>
            <div className="bg-white rounded-lg p-3 border border-stone-200 shadow-sm">
              <div className="flex items-center space-x-2 mb-1">
                <AlertCircle className="w-4 h-4 text-red-600" />
                <span className="text-xs text-stone-500">Overdue</span>
              </div>
              <p className="text-2xl font-bold text-stone-900">2</p>
            </div>
            <div className="bg-white rounded-lg p-3 border border-stone-200 shadow-sm">
              <div className="flex items-center space-x-2 mb-1">
                <TrendingUp className="w-4 h-4 text-slate-600" />
                <span className="text-xs text-stone-500">Progress</span>
              </div>
              <p className="text-2xl font-bold text-stone-900">68%</p>
            </div>
          </div>
          
          {/* Recent decisions */}
          <div className="space-y-3">
            <h4 className="text-sm font-semibold text-stone-700">Recent Decisions</h4>
            
            <div className="bg-gradient-to-r from-green-50 to-green-100/50 rounded-lg p-4 border border-green-200 shadow-sm">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center space-x-2 mb-1">
                    <CheckCircle2 className="w-4 h-4 text-green-600" />
                    <span className="text-sm font-semibold text-stone-900">Floor tiles selection approved</span>
                  </div>
                  <p className="text-xs text-stone-600">Italian marble - RAK Ceramics</p>
                  <p className="text-xs text-stone-500 mt-1">Approved 2 days ago by Priya Sharma</p>
                </div>
                <span className="text-xs text-green-700 font-medium">₹4.2L</span>
              </div>
            </div>
            
            <div className="bg-gradient-to-r from-amber-50 to-amber-100/50 rounded-lg p-4 border border-amber-200 shadow-sm">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center space-x-2 mb-1">
                    <Clock className="w-4 h-4 text-amber-600" />
                    <span className="text-sm font-semibold text-stone-900">Kitchen modular design</span>
                  </div>
                  <p className="text-xs text-stone-600">L-shaped with island - Sleek Kitchens</p>
                  <p className="text-xs text-stone-500 mt-1">Awaiting client response</p>
                </div>
                <span className="text-xs text-amber-700 font-medium">₹6.8L</span>
              </div>
            </div>
            
            <div className="bg-gradient-to-r from-slate-50 to-slate-100/50 rounded-lg p-4 border border-slate-200 shadow-sm">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center space-x-2 mb-1">
                    <Clock className="w-4 h-4 text-slate-600" />
                    <span className="text-sm font-semibold text-stone-900">Lighting fixtures - Living room</span>
                  </div>
                  <p className="text-xs text-stone-600">Pendant + cove lighting</p>
                  <p className="text-xs text-stone-500 mt-1">Review in progress</p>
                </div>
                <span className="text-xs text-slate-700 font-medium">₹1.2L</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Floating badge - Project milestone */}
      <div className="absolute -top-4 -left-4 bg-white rounded-xl shadow-xl p-4 border-2 border-slate-200 z-10">
        <div className="flex items-center space-x-2">
          <div className="w-3 h-3 bg-blue-500 rounded-full animate-pulse"></div>
          <span className="text-sm font-semibold text-stone-900">3 new updates</span>
        </div>
      </div>
      
      {/* Floating badge - BOQ summary */}
      <div className="absolute -bottom-4 -right-4 bg-white rounded-xl shadow-xl p-5 border-2 border-slate-200 z-10">
        <div className="space-y-1">
          <p className="text-sm text-stone-500">Total BOQ Value</p>
          <p className="text-2xl font-bold text-slate-600">₹42.8L</p>
          <p className="text-xs text-green-600 font-medium">↑ 12% from estimate</p>
        </div>
      </div>
    </div>
  );
};

export default ProductMockup;
